function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 15.5v5a1 1 0 001 1h1a3 3 0 006 0h6a3 3 0 006 0h1a1 1 0 001-1v-12a3 3 0 00-3-3h-9a3 3 0 00-3 3v2H9a3 3 0 00-2.4 1.2l-2.4 3.2a.61.61 0 00-.07.14l-.06.11a1 1 0 00-.07.35zm16 6a1 1 0 112 0 1 1 0 01-2 0zm-7-13a1 1 0 011-1h9a1 1 0 011 1v11h-.78a3 3 0 00-4.44 0H13v-11zm-2 6H7l1.2-1.6a1 1 0 01.8-.4h2v2zm-3 7a1 1 0 112 0 1 1 0 01-2 0zm-2-5h5v2.78a3 3 0 00-4.22.22H6v-3z",
  fill: "currentColor",
  fillRule: "nonzero"
})));